import React from 'react'
import Icon from '../Icon'
import { GrowingIconProps, Size } from './types'
import style from './GrowingIcon.module.scss'
import classnames from 'classnames'

const GrowingIcon: React.FC<GrowingIconProps> = props => {

  const { size = Size.REGULAR } = props
  const haloColor = props.icon?.haloColor ?? props.haloColor

  const growingIconClasses = classnames(
    style['GrowingIcon'], {
      [style['GrowingIcon--hovered']]: props.hovered,
      [style['GrowingIcon--selected']]: props.selected,
      [style['GrowingIcon--small']]: size === Size.SMALL,
      [style['GrowingIcon--regular']]: size === Size.REGULAR,
      [style['GrowingIcon--large']]: size === Size.LARGE,
      [style['GrowingIcon--maintain-colour']]: props.icon?.maintainColorWhenSelected
    }
  )

  const haloClasses = classnames(
    style['GrowingIcon-halo'], {
      [style[`GrowingIcon-halo--complimentary-${props.icon.colour}`]]:
        typeof props.icon.colour !== 'undefined' &&
        props.selected &&
        !haloColor &&
        style[`GrowingIcon-halo--complimentary-${props.icon.colour}`],
      [style[`GrowingIcon-halo--${haloColor}`]]:
        typeof haloColor !== 'undefined' &&
        style[`GrowingIcon-halo--${haloColor}`]
    }
  )

  return <div className={growingIconClasses} data-bdd={props.dataBdd} >
    <div className={style['GrowingIcon-layer']} >
      <div className={haloClasses} data-bdd={props.dataBdd ? `${props.dataBdd}-halo` : undefined} />
    </div>
    <div className={style['GrowingIcon-layer']}>
      <Icon { ...props.icon } className={style['GrowingIcon-icon']} />
    </div>
  </div>

}

export default GrowingIcon
